import { Injectable } from '@angular/core';
import { Http, Response, Headers, ResponseContentType } from '@angular/http';
import { CostAnalysisShowDetail } from './costanalysisshowdetails';
import { Observable } from 'rxjs/Observable';
import { CONFIGURATION } from '../app.config';

@Injectable()
export class CostAnalysisShowService {
    private _CostshowServiceReportUrl = CONFIGURATION.baseServiceUrl + 'productionshowservicereport/';
    constructor(private _http: Http) { }

    getCompany(): Observable<any> {
        const headers = new Headers();
        headers.append('Client-Id', 'REPORTING-PORTAL-API-CLIENT');
        headers.append('Client-Secret', '0667b514-28a8-4928-9aa4-1ffe290ebcd2');
        return this._http.get(this._CostshowServiceReportUrl + 'getcompany', { headers: headers })
            .map((response: Response) => response.json())
            .catch(this.handleError);
    }
    getProduction(companyName: any): Observable<any> {
        const headers = new Headers();
        headers.append('Client-Id', 'REPORTING-PORTAL-API-CLIENT');
        headers.append('Client-Secret', '0667b514-28a8-4928-9aa4-1ffe290ebcd2');
        return this._http.get(this._CostshowServiceReportUrl + 'getproductions?CompanyName=' + companyName,
            { headers: headers })
            .map((response: Response) => response.json())
            .catch(this.handleError);
    }
    getsource(data:any){
        const headers = new Headers();
        headers.append('Client-Id', 'REPORTING-PORTAL-API-CLIENT');
        headers.append('Client-Secret', '0667b514-28a8-4928-9aa4-1ffe290ebcd2');
        return this._http.post(this._CostshowServiceReportUrl + 'getsource', data, { headers: headers })
            .map((response: Response) => response.json())
            .catch(this.handleError);
    }

    getProductionCost(selectedProduction: any, selectedCompany: any, selectedStartDate: any, selectedEndDate: any, selectedSource:any):
        Observable<CostAnalysisShowDetail[]> {
        if (selectedCompany == undefined) selectedCompany = '1';
        if (selectedStartDate == undefined) selectedStartDate = '1';
        if (selectedEndDate == undefined) selectedEndDate = '1';
        const headers = new Headers();
        headers.append('Client-Id', 'REPORTING-PORTAL-API-CLIENT');
        headers.append('Client-Secret', '0667b514-28a8-4928-9aa4-1ffe290ebcd2');
        const fileName = 'getproductionshowreportdata?ProductionName=' + selectedProduction
            + '&CompanyName=' + selectedCompany + '&sourceList='+ selectedSource + '&StartDate=' + selectedStartDate +
            '&EndDate=' + selectedEndDate;
        return this._http.get(this._CostshowServiceReportUrl + fileName, { headers: headers })
            .map((response: Response) => <CostAnalysisShowDetail[]>response.json())
            .catch(this.handleError);
    }
    getAvgCount(): Observable<any> {
        const headers = new Headers();
        headers.append('Client-Id', 'REPORTING-PORTAL-API-CLIENT');
        headers.append('Client-Secret', '0667b514-28a8-4928-9aa4-1ffe290ebcd2');
        return this._http.get(this._CostshowServiceReportUrl + 'getProductionShowAverageCount', { headers: headers })
            .map((response: Response) => response.json())
            .catch(this.handleError);
    }

    downloadExcelReport(selectedStartDate: any, selectedEndDate: any, selectedProduction: any, companyName: any, selectedsource:any) {
        if ("''" === companyName) companyName = '1';
        const fileName = 'excel-download?StartDate=' + selectedStartDate
            + '&EndDate=' + selectedEndDate + '&ProductionName=' + selectedProduction +
            '&CompanyName=' + companyName + '&SourceName=' + selectedsource;
        const url = this._CostshowServiceReportUrl + fileName
        const headers = new Headers();
        headers.append('Client-Id', 'REPORTING-PORTAL-API-CLIENT');
        headers.append('Client-Secret', '0667b514-28a8-4928-9aa4-1ffe290ebcd2');
        return this._http.get(url, { headers: headers, responseType: ResponseContentType.Blob }).map(
            (res) => {
                const a = document.createElement('a');
                document.body.appendChild(a);
                const blob = new Blob([res.blob()], { type: 'application/zip' });
                const downloadUrl = URL.createObjectURL(blob);
                window.open(downloadUrl);
            })

    }
    private handleError(error: Response) {
        // in a real world app, we may send the server to some remote logging infrastructure
        // instead of just logging it to the console
        console.error(error);
        return Observable.throw(error.json().error || 'Failed in web api(Server error) ');
    }

    getReportData(data: any): Observable<any> {
        const headers = new Headers();
        headers.append('Client-Id', 'REPORTING-PORTAL-API-CLIENT');
        headers.append('Client-Secret', '0667b514-28a8-4928-9aa4-1ffe290ebcd2');
        return this._http.post(this._CostshowServiceReportUrl + `v2/getproductionshowreportdata`,data, { headers: headers })
          .map((res: Response) => res.json())
          .catch(this.handleError);
      }
}



// WEBPACK FOOTER //
// ./src/app/costanalysisshow/costanalysisshow.service.ts